/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_online_sections_4_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the first few minutes to find the input cells, formula bar and sheet tabs in the budget sample. Select a category amount and read the formula bar before changing it. This tells you whether you are looking at a typed input or a calculated result. If a total is based on other cells, edit those inputs instead of replacing the total with a number that only looks correct.`)
};

const zh_gc_search_guides_gridcraft_online_sections_4_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先用几分钟找到预算示例中的输入单元格、公式栏和工作表标签。选中某项金额后，修改前先看公式栏，判断它是直接输入还是计算结果。如果合计依赖其他单元格，应修改输入，而不是把合计替换成一个看似正确的数字。`)
};

/**
* | output |
* | --- |
* | "Use the first few minutes to find the input cells, formula bar and sheet tabs in the budget sample. Select a category amount and read the formula bar before ..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_4_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_4_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_4_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_online_sections_4_paragraphs_0 as "gc.search_guides.gridcraft_online.sections.4.paragraphs.0" }